<template>
  <div class="">
    <div class="d-flex">
      <v-btn fab text small color="grey darken-2" @click="prev">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer />
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer />
      <v-btn fab text small @click="next">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
    <v-calendar
      v-model="calendar"
      :events="events"
      :event-color="event => event.color"
      :weekdays="weekdays"
      ref="calendar"
      @click:date="handleDayClick"
      @click:day="handleDayClick"
    />
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "BasicCalendar",
  data() {
    return {
      calendar: new Date().toISOString()
    };
  },
  computed: {
    title() {
      const displayedDate = moment(this.calendar);
      return displayedDate.format("MMMM YYYY");
    }
  },
  props: {
    events: {
      type: Array,
      required: true
    },
    weekdays: {
      type: Array,
      required: true
    }
  },
  methods: {
    prev() {
      this.$refs.calendar.prev();
      this.$emit("onDateChange", this.calendar);
    },
    next() {
      this.$refs.calendar.next();
      this.$emit("onDateChange", this.calendar);
    },
    handleDayClick(val) {
      this.$emit("onDayClick", val);
    }
  }
};
</script>

<style lang="scss"></style>
